import React from 'react'
import LocalizedText from '../../presentational/LocalizedText'
import LoadingIndicator from "../../presentational/LoadingIndicator";

interface VerifyEmailUpdateProps {
  serverError: string;
  isLoading: boolean;
}

const VerifyEmailUpdate: React.FC<VerifyEmailUpdateProps> = ({ serverError, isLoading }) => {
  return (
    <div className="login-action">
      <h1><LocalizedText textKey="participant-login-verify-email-title" /></h1>
      {
        serverError && (
          <p className="server-error">{serverError}</p>
        )
      }
      {
        !isLoading && !serverError && (
          <p><LocalizedText textKey="participant-login-verify-email-confirmation" /></p>
        )
      }
      {
        isLoading && (
           <LoadingIndicator />
        )
      }
    </div>
  )
}

export default VerifyEmailUpdate